// This file was auto-generated by Fern from our API Definition.
import * as FernIr from "../../../../../index.mjs";
export const Response = {
    json: () => {
        return {
            type: "json",
            _visit: function (visitor) {
                return FernIr.dynamic.Response._visit(this, visitor);
            },
        };
    },
    streaming: () => {
        return {
            type: "streaming",
            _visit: function (visitor) {
                return FernIr.dynamic.Response._visit(this, visitor);
            },
        };
    },
    streamParameter: () => {
        return {
            type: "streamParameter",
            _visit: function (visitor) {
                return FernIr.dynamic.Response._visit(this, visitor);
            },
        };
    },
    fileDownload: () => {
        return {
            type: "fileDownload",
            _visit: function (visitor) {
                return FernIr.dynamic.Response._visit(this, visitor);
            },
        };
    },
    text: () => {
        return {
            type: "text",
            _visit: function (visitor) {
                return FernIr.dynamic.Response._visit(this, visitor);
            },
        };
    },
    bytes: () => {
        return {
            type: "bytes",
            _visit: function (visitor) {
                return FernIr.dynamic.Response._visit(this, visitor);
            },
        };
    },
    _visit: (value, visitor) => {
        switch (value.type) {
            case "json":
                return visitor.json();
            case "streaming":
                return visitor.streaming();
            case "streamParameter":
                return visitor.streamParameter();
            case "fileDownload":
                return visitor.fileDownload();
            case "text":
                return visitor.text();
            case "bytes":
                return visitor.bytes();
            default:
                return visitor._other(value);
        }
    },
};
